module.exports = __webpack_public_path__ + "static/media/shuri-atomi-icon.e80d2c42.jpg";